export default __webpack_public_path__ + "static/media/bike_card_1.cfafa777.png";